export default __webpack_public_path__ + "static/media/vc5.0152a0ff.jpg";